import dayjs from "dayjs";

import localizedFormat from 'dayjs/plugin/localizedFormat';

export default {
    install( Vue: any, options: any ) {
        dayjs.extend( localizedFormat )
        Vue.prototype.$dayjs = dayjs
    }
};